import Swiper, {Autoplay, Navigation} from 'swiper';

Swiper.use([Autoplay, Navigation]);

let className = '.offer__slider .swiper-container';

export default () => {
    let container = document.querySelector(className);

    if (container) {
        let offerSlider = slider(container);
        sliderArrows(offerSlider);

        window.addEventListener('resize', () => {
            slidesHeight(className);
        });
    }

    $('a[href^="#"]').on('click', function(e) {
        e.preventDefault();
    
        var target = $(this).attr('href');
        var offset = ($(target).offset().top - 120); 
        $('html, body').animate({
            scrollTop: offset
        }, 'slow');
    });    
}

let slider = (container) => {
    let swiper = new Swiper(container, {
        slidesPerView: 1,
        spaceBetween: 20,
        loop: false,
        breakpoints: {
            576: {
                slidesPerView: 2,
                spaceBetween: 20,
            },
            1300: {
                slidesPerView: 4,
                spaceBetween: 20,
            },
            1440: {
                slidesPerView: 4,
                spaceBetween: 50,
            },
        }
    });

    swiper.on('update', function () {
        slidesHeight(className);
    });

    swiper.update();

    return swiper;
}


let sliderArrows = (swiper) => {
    let prev = document.querySelector('.offer__slider-arrow--prev');
    let next = document.querySelector('.offer__slider-arrow--next');

    prev.addEventListener('click', function () {
        swiper.slidePrev(500, false);
    })

    next.addEventListener('click', function () {
        swiper.slideNext(500, false);
    })
}

let slidesHeight = (className) => {
    let container = document.querySelector(className);
    let slides = container.querySelectorAll('.swiper-slide');

    slides.forEach((slide) => {
        slide.style.height = slide.offsetWidth + 'px';
    });
}
